__turbopack_context__.v({
  "agree_btn": "NotWorkingHour-module-scss-module__bRYmrq__agree_btn",
  "contents": "NotWorkingHour-module-scss-module__bRYmrq__contents",
  "description": "NotWorkingHour-module-scss-module__bRYmrq__description",
  "lottie": "NotWorkingHour-module-scss-module__bRYmrq__lottie",
  "next_child_div": "NotWorkingHour-module-scss-module__bRYmrq__next_child_div",
  "term_section": "NotWorkingHour-module-scss-module__bRYmrq__term_section",
  "title": "NotWorkingHour-module-scss-module__bRYmrq__title",
});
